import React from 'react';
import { useIntl } from 'react-intl';
import { Feature } from '../../features/types';
import { Features } from '../../features/Features';
import { artistFeature, playlistFeature, releaseFeature } from '../../features/messages';

export const features: Feature[] = [artistFeature, releaseFeature, playlistFeature];
export const SmartlinksLinkfireAlternativeExplore: React.FC = () => {
  const intl = useIntl();
  return (
    <Features
      title={intl.formatMessage({
        id: 'sml.web.smart-links.linkfire_alternative.explore.title',
        defaultMessage: 'Your music deserves more'
      })}
      features={features}
    >
      <p className="main-header-subtitle text-center">
        {intl.formatMessage({
          id: 'sml.web.smart-links.linkfire_alternative.explore.description',
          defaultMessage:
            'Music24 shares your songs, albums and playlists across all platforms and lets you present it on a trackable, promotional landing page'
        })}
      </p>
    </Features>
  );
};
